module.exports = __webpack_public_path__ + "img/dnt.8f869cfe.svg";